// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  styled,
} from '@mui/material';

// ----------------------------------------------------------------------

type Props = RadioGroupProps & {
  name: string;
  options: { label: string; value: any }[];
  label?: string;
  spacing?: number;
  helperText?: React.ReactNode;
  readonly: boolean;
};

export default function RHFRadioGroup({
  row,
  name,
  label,
  options,
  spacing,
  helperText,
  readonly = false,
  ...other
}: Props) {
  const { control } = useFormContext();

  const labelledby = label ? `${name}-${label}` : '';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset">
          {label && (
            <FormLabel component="legend" id={labelledby} sx={{ typography: 'body2' }}>
              {label}
            </FormLabel>
          )}

          <RadioGroupContainer {...field} aria-labelledby={labelledby} row={row} {...other}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<CustomRadio />}
                label={option.label}
                sx={{
                  '&:not(:last-of-type)': {
                    mb: spacing || 0,
                  },
                  ...(row && {
                    mr: 0,
                    '&:not(:last-of-type)': {
                      mr: spacing || 2,
                    },
                  }),
                }}
                disabled={readonly}
              />
            ))}
          </RadioGroupContainer>

          {(!!error || helperText) && (
            <FormHelperText error={!!error} sx={{ mx: 0 }}>
              {error ? error?.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}

// 커스텀 Radio 스타일링
const RadioGroupContainer = styled(RadioGroup)(({ theme }) => ({
  marginLeft: '15px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));
// 커스텀 Radio 스타일링
const CustomRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.primary.main, // 선택된 상태의 색상
  },
  '& svg': {
    color: theme.palette.grey[500], // 기본 상태의 색상
  },
  '&.Mui-checked svg': {
    color: theme.palette.primary.main, // 선택된 상태의 아이콘 색상
  },
}));
